import { SvgLightbulb } from "@itwin/itwinui-icons-react";
import { MenuItem } from "@itwin/itwinui-react";

export const ShareIdeaMenuItem = ({ close }: { close: () => void }) => {

  const onClick = () => {
    window.open("https://itwinplatform.ideas.aha.io", "_blank");
    close();
  };

  return (
    <MenuItem
      icon={<SvgLightbulb />}
      onClick={onClick}
    >
      Share an Idea
    </MenuItem>
  )
}
